export default {
  TOKEN_KEY: process.env.REACT_APP_AUTH_CODE || 'metalspace-auth-token',
  API_ENDPOINT: 'https://still-wave-10274.herokuapp.com/',
  USER_ID: process.env.REACT_APP_USER_ID || 'user_id'
};
